import { Component, OnInit } from '@angular/core';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { AuditFilter } from 'projects/shared/src/lib/models/AuditFilter';
import { AgGridAuditSettings } from './AgGridAuditSettings'; // Adjust the path if needed
import { IDatasource, GridApi, GridOptions, IGetRowsParams, ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'manage-audit',
  templateUrl: './manage-audit.component.html',
  styleUrls: ['./manage-audit.component.scss']
})
export class ManageAuditComponent implements OnInit {

  constructor(
    private tenantService: TenantService,
    private notificationService: NotificationService,
    private translate: TranslateService
  ) { }
  emptyGuid = '00000000-0000-0000-0000-000000000000';
  auditData: any = [];
  auditFilter: AuditFilter = new AuditFilter(); // alle Einträge in der Audit-Tabelle werden aufbereitet

  isLoadingResults: boolean = false;
  isRateLimitReached: boolean = false;
  isAuthenticated: boolean = false;
  filter: GenericFilter = new GenericFilter();
  rowData: any = [];
  frameworkComponents: any;
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
//  filter!: GenericFilter;
  aggridSettings!:AgGridAuditSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  ngOnInit() {
    this.work();
  }

    work() {
      //let profileMap = new Map<string, UserProfileForCreation>();
      // this.isAuthenticated$ = this.oauthService.isLoggedIn;
      // this.isAuthenticated$.subscribe({
      //   next: (isAuthenticated) => {
      //     this.isAuthenticated = isAuthenticated;
      //   }
      // });
  
      this.filter = new GenericFilter();
      //console.log("-------> user management _userRoles = ", this._userRoles)
      this.aggridSettings = new AgGridAuditSettings(this.translate);
      //this.frameworkComponents = {buttonRenderer: ApitokensButtonRendererComponent}
      this.gridOptions = this.aggridSettings.agGridAuditSettings;
  
      this.ds = {
        rowCount: 0,
        getRows: (params: IGetRowsParams) => {
  
          this.filter.className = 'ApiTokens';
          this.filter.startRow = params.startRow;
          this.filter.endRow = params.endRow;
          this.filter.sortItems = params.sortModel;
          this.filter.clientFilters = params.filterModel;
  
          this.gridApi.showLoadingOverlay();
          this.isLoadingResults = true;
  
          // if (this._apiTokenForALL) {
            this.tenantService.getFilteredAuditLog(this.tenantService.currentTenantName, this.filter).subscribe({
              next: (tokens) => {
                if (tokens.length > 0) {
                  this.rowData = tokens;
                  console.log("-----------------> manage-audit rowData ", this.rowData)
                  this.rowData = this.rowData.slice(params.startRow, params.endRow);
                  let lastRow = -1;     
                  if (tokens.length <= params.endRow) {
                    lastRow = tokens.length;
                  }
                  params.successCallback(this.rowData, lastRow);
                  this.isLoadingResults = false;
                  this.isRateLimitReached = false;      
                  this.gridApi.hideOverlay();
                }
                else { // no tokens
                  this.notificationService.info(`${this.translate.data["INFO"]}`, "Kein Audit Log vorhanden!")
                  let lastRow = -1;
                  if (tokens.length <= params.endRow) {
                    lastRow = tokens.length;
                  }
                  params.successCallback(this.rowData, lastRow);
                  this.isLoadingResults = false;
                  this.isRateLimitReached = false;
                  this.gridApi.hideOverlay();  
                }
              },
              error: (error: any) => {
                this.isLoadingResults = false;
                //this.isRateLimitReached = true;
                this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler Audit Liste")
                console.log("------> error: ", error.error);
                this.notificationService.info("", error.error);
            }
            });
            }
          // else {
          //   this.tenantService.getApiTokens(this.tenantService.currentTenantName, this.ownUserId, this.filter).subscribe({
          //     next: (tokens) => {
          //       if (tokens.length > 0) {
          //         this.rowData = tokens;
          //         //console.log("manage-apitokens rowData ", this.rowData)
          //         this.rowData = this.rowData.slice(params.startRow, params.endRow);
          //         let lastRow = -1;     
          //         if (tokens.length <= params.endRow) {
          //           lastRow = tokens.length;
          //         }
          //         params.successCallback(this.rowData, lastRow);
          //         this.isLoadingResults = false;
          //         this.isRateLimitReached = false;      
          //         this.gridApi.hideOverlay();
          //       }
          //       else { // no tokens
          //         this.notificationService.info(`${this.translate.data["INFO"]}`, "Kein Api Token vorhanden!")
          //         let lastRow = -1;
          //         if (tokens.length <= params.endRow) {
          //           lastRow = tokens.length;
          //         }
          //         params.successCallback(this.rowData, lastRow);
          //         this.isLoadingResults = false;
          //         this.isRateLimitReached = false;
          //         this.gridApi.hideOverlay();  
          //       }
          //     },
          //     error: (error: any) => {
          //       this.isLoadingResults = false;
          //       //this.isRateLimitReached = true;
          //       this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler Api Token Liste")
          //       console.log("------> error: ", error)
          //       this.notificationService.info("", error)
          //   }
          //   });
          // }
        }
      };
  
    onGridReady(params: any) {
      this.gridApi = params.api;    
      this.gridApi.sizeColumnsToFit();    
      this.gridApi.setDatasource(this.ds)
    }
  
  
  exportAuditData() {
    // this.tenantService.getFilteredAuditLog(this.tenantService.currentTenantName, new GenericFilter()).subscribe({
    //   next: (response) => {
    //     //this.isLoadingResults = false;
    //     //this.isRateLimitReached = true;
    //   // this.notificationService.success("", "Excel Datei wird erstellt!");
    //     console.log("------> response: ", response)
    //   },
    //   error: (error: any) => {
    //     // this.isLoadingResults = false;
    //     //this.isRateLimitReached = true;
    //     this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler Audit Log Export")
    //     console.log("------> error: ", error)
    //     this.notificationService.info("", error)
    //   }
    // });

    this.tenantService.exportAuditLog(this.tenantService.currentTenantName, this.auditFilter).subscribe({
      next: (response) => {
        //this.isLoadingResults = false;
        //this.isRateLimitReached = true;
      this.notificationService.success("", "Excel Datei wird erstellt und steht in Kürze unter Dateidownload bereit!");
        // console.log("------> response: ", response)
      },
      error: (error: any) => {
        // this.isLoadingResults = false;
        //this.isRateLimitReached = true;
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler Audit Log Export")
        console.log("------> error: ", error)
        this.notificationService.info("", error)
      }
    });


  }
}
